import { render, staticRenderFns } from "./QuestionEditView.vue?vue&type=template&id=e0905220&scoped=true"
import script from "./QuestionEditView.vue?vue&type=script&lang=js"
export * from "./QuestionEditView.vue?vue&type=script&lang=js"
import style0 from "./QuestionEditView.vue?vue&type=style&index=0&id=e0905220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0905220",
  null
  
)

export default component.exports